import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ab05c7aa-1b14-4fc7-8b6f-1f6c043f72da/artifacts/9wfik0s6_logo%20complet%20sombre1.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#071428] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={LOGO_URL} alt="Finovéo" className="h-10 w-auto mb-5" />
            <p className="text-slate-400 text-sm leading-relaxed">
              Le partenaire digital des artisans et petites entreprises. Structuration, digitalisation et optimisation de votre activité.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: "Accueil", path: "/" },
                { label: "Services", path: "/services" },
                { label: "Clients cibles", path: "/clients" },
                { label: "Processus", path: "/processus" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-400 hover:text-[#59C3A6] text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4 text-sm uppercase tracking-wider">Entreprise</h4>
            <ul className="space-y-3">
              {[
                { label: "A propos", path: "/a-propos" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-400 hover:text-[#59C3A6] text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://calendly.com/finoveo-conseil/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-[#59C3A6] text-sm transition-colors inline-flex items-center gap-1"
                >
                  Réserver un appel <ArrowUpRight size={12} />
                </a>
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4 text-sm uppercase tracking-wider">Prêt à démarrer ?</h4>
            <p className="text-slate-400 text-sm mb-4 leading-relaxed">
              Demandez votre diagnostic gratuit et découvrez les leviers de croissance de votre activité.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 bg-[#59C3A6] text-[#0B1F3B] font-semibold px-6 py-2.5 rounded-full text-sm hover:bg-[#4AB095] transition-all duration-300 hover:scale-105"
            >
              Diagnostic gratuit
              <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            &copy; {new Date().getFullYear()} Finovéo Conseil. Tous droits réservés.
          </p>
          <div className="flex items-center gap-2 text-slate-500 text-xs">
            <span>Digitalisation</span>
            <span className="text-[#59C3A6]">·</span>
            <span>Automatisation</span>
            <span className="text-[#59C3A6]">·</span>
            <span>Intelligence Artificielle</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
